import {
  Button,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Select,
  InputAdornment,
  Radio,
  RadioGroup,
  Typography,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import ResponsiveDialog from "../../../Components/DialogBox";
import { useFormik } from "formik";
import CustomTextField from "../../../Components/TextField";
import { useErrorHandler } from "../../../hooks";
import * as yup from "yup";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import { useState, useEffect, useRef } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  createProgramDetails,
  updateProgramDetails,
  updateProgramPublishStatus,
  getExploreContent,
} from "../../../Redux/Actions/ProgramAction";
import rightArrow from "../../../Assets/Images/right-arrow.png";
import MyEditor from "../../../Components/MyEditor";
export function ProgramForm({ setStepOneData, formValue }) {
  const { setMsgConfig } = useErrorHandler();
  const [isVisibleDialog, setIsVisibleDialog] = useState(false);
  const dispatch = useDispatch();
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);

  //get data for program
  const { isEdit, getProgramDetails, createProgram, contentList } = useSelector(
    (state) => state?.Program
  );
  //style for select
  const ITEM_HEIGHT = 48;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
        maxWidth: ITEM_HEIGHT * 3.5,
      },
    },
  };
  //state for programDetails
  const [programsDetails, setProgramsDetails] = useState({
    programTitle: "",
    contributorName: "",
    duration: "",
    explore_id: [],
    commitmentLevel: "",
    coverImage: "",
    shortDescription: "",
    fullDescription: "",
    trailer: "",
    trailer_duration: null,
  });

  //dispatch for getting explores
  useEffect(() => {
    dispatch(getExploreContent());
  }, [dispatch]);

  //set proDetails
  useEffect(() => {
    !isEdit &&
      createProgram?.programDetails &&
      createProgram?.programDetails?.map((item) => {
        setProgramsDetails({
          programId: item.id,
          programTitle: item.title,
          contributorName: item.contributor_name,
          duration: item.duration,
          explore_id: item.explore_id,
          commitmentLevel: item.commitment_level,
          coverImage: item.cover_img,
          shortDescription: item.short_description,
          fullDescription: item.full_description,
          trailer: item.trailer,
          trailer_duration: item.trailer_duration,
        });
      });
  }, [createProgram?.programDetails]);

  //set duration
  function handleDuration(e) {
    formik.setFieldValue("duration", e.target.value);
    if (programsDetails) {
      e.target.value < programsDetails?.duration
        ? setIsVisibleDialog(true)
        : setIsVisibleDialog(false);
    }
    if (isEdit && getProgramDetails) {
      e.target.value < getProgramDetails?.duration
        ? setIsVisibleDialog(true)
        : setIsVisibleDialog(false);
    }
  }
  //manage press enterKey
  const handleKeyPress1 = (event) => {
    if (event?.key == "Enter") {
      formik.setTouched({ ...formik.touched, coverImage: true });
      fileInputRef1?.current?.click();
    }
  };
  const handleKeyPress2 = (event) => {
    if (event?.key == "Enter") {
      formik.setTouched({ ...formik.touched, trailer: true });
      fileInputRef2?.current?.click();
    }
  };
  //handle explore content
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    formik.setFieldValue(
      "explore_id",
      typeof value === "array" ? value.split(",") : value
    );
  };
  //form handling using formik and validate form using yup
  const formik = useFormik({
    initialValues: {
      programTitle:
        (!isEdit && programsDetails?.programTitle) ||
        (isEdit && getProgramDetails?.title) ||
        "",
      contributorName:
        (!isEdit && programsDetails?.contributorName) ||
        (isEdit && getProgramDetails?.contributor_name) ||
        "",
      duration:
        (!isEdit && programsDetails?.duration) ||
        (isEdit && getProgramDetails?.duration) ||
        "",
      explore_id:
        (!isEdit && programsDetails?.explore_id) ||
        (isEdit && getProgramDetails?.explore_id) ||
        [],
      commitmentLevel:
        (!isEdit && programsDetails?.commitmentLevel) ||
        (isEdit && getProgramDetails?.commitment_level) ||
        "",
      coverImage:
        (!isEdit && programsDetails?.coverImage) ||
        (isEdit && getProgramDetails?.cover_img) ||
        "",
      shortDescription:
        (!isEdit && programsDetails?.shortDescription) ||
        (isEdit && getProgramDetails?.short_description) ||
        "",
      fullDescription:
        (!isEdit && programsDetails?.fullDescription) ||
        (isEdit && getProgramDetails?.full_description) ||
        "",
      trailer:
        (!isEdit && programsDetails?.trailer) ||
        (isEdit && getProgramDetails?.trailer) ||
        "",
      trailer_duration:
        (!isEdit && programsDetails?.trailer_duration) ||
        (isEdit && getProgramDetails?.trailer_duration) ||
        null,
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      programTitle: yup
        .string()
        .required("Program Title Required")
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        ),
      contributorName: yup
        .string()
        .required("contributor Name Required")
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        ),
      duration: yup
        .number()
        .typeError("Duration must be nummber")
        .required()
        .transform((value, originalValue) =>
          /\s/.test(originalValue) ? NaN : value
        )
        .min(1, "Weeks Must Be above 1 Weeks")
        .max(52, "Weeks Must Be below 52 Weeks")
        .transform((value, originalValue) =>
          /\s/.test(originalValue) ? NaN : value
        ),
      explore_id: yup
        .array()
        .min(1, "Please must be select atleast one content")
        .of(yup.string().required())
        .required(),
      commitmentLevel: yup.string().required("Please Select commitmentLevel"),
      coverImage: yup
        .mixed()
        .required("A file is required")
        .test("fileFormat", "JPEG JPG AND PNG Files only", (value) => {
          const file = new File([value], "tempimage", {
            type: value?.type || "image/jpg",
          });
          return (
            !file ||
            (file &&
              ["image/jpeg", "image/png", "image/jpg"].includes(file?.type))
          );
        }),
      shortDescription: yup
        .string()
        .required("Please Enter shortDescription")
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        ),
      fullDescription: yup
        .string()
        .required("Please Enter full Description")
        .matches(
          /^\S.*/,
          "* This field cannot contain whitepaces at first letter"
        ),
      trailer: yup
        .mixed()
        .required("A file is required")
        .test(
          "fileFormat",
          "Please Select MP4 File or IMAGE File ",
          (value) => {
            const file = new File([value], "tempvideo", {
              type: value?.type || "video/mp4",
            });
            return (
              !file ||
              (file &&
                ["video/mp4", "image/jpeg", "image/jpg", "image/png"].includes(
                  file?.type
                ))
            );
          }
        ),
    }),
    onSubmit: (values) => {
      const data = new FormData();
      data.append("title", values.programTitle);
      data.append("contributor_name", values.contributorName);
      data.append("duration", values.duration);
      data.append("short_description", values.shortDescription);
      data.append("full_description", values.fullDescription);
      data.append("cover_img", values.coverImage);
      data.append("trailer", values.trailer);
      data.append("commitment_level", values.commitmentLevel);
      (getProgramDetails &&
        getProgramDetails?.id &&
        data.append("Id", getProgramDetails?.id)) ||
        (createProgram.programDetails &&
          programsDetails?.programId &&
          data.append("Id", programsDetails?.programId));
      data.append("explore_id", JSON.stringify(formik.values.explore_id));
      data.append("trailer_duration", values.trailer_duration);
      if (isEdit) {
        //dispatch for update Program.
        dispatch(updateProgramDetails(data));
        setMsgConfig({
          alertOpen: true,
          message: "Program Update successfully!",
          severity: "success",
          autoHideDuration: 2000,
        });
        if(getProgramDetails?.is_publish === false){
          const payload = {
            Id: getProgramDetails?.id,
            is_draft: true,
          };
          dispatch(updateProgramPublishStatus(payload));
        }  
        setStepOneData(formik.values);
      } else {
        const isEmpty = Object.values(programsDetails).every(
          (value) =>
            value === "" ||
            value === null ||
            (Array.isArray(value) && value.length === 0)
        );

        if (isEmpty) {
          //dispatch for create Program.
          dispatch(createProgramDetails(data));
          setMsgConfig({
            alertOpen: true,
            message: "Program Created successfully!",
            severity: "success",
            autoHideDuration: 2000,
          });
          setStepOneData(formik.values);
        } else {
          //dispatch for create time update Program.
          dispatch(updateProgramDetails(data));
          setMsgConfig({
            alertOpen: true,
            message: "Program Update successfully!",
            severity: "success",
            autoHideDuration: 2000,
          });
          setStepOneData(formik.values);
        }
      }
    },
  });

  return (
    <>
      <ResponsiveDialog
        open={isVisibleDialog}
        header="If You Reduce Week Then Data Of That Week Are Removed."
        dtype="msg"
        onClose={() => setIsVisibleDialog(false)}
      ></ResponsiveDialog>
      <Grid container spacing={3} sx={{ my: 1 }}>
        <Grid item xs={12}>
          <CustomTextField
            // variant="standard"
            fieldType="textInput"
            name="programTitle"
            label="Program Title"
            placeholder={"Enter Your Program Title"}
            fullWidth
            required
            value={formik.values.programTitle}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.programTitle && formik.errors.programTitle
                ? true
                : false
            }
          />
          {formik.touched.programTitle && formik.errors.programTitle && (
            <FormHelperText className="error_message">
              {formik.errors.programTitle}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            fieldType="textInput"
            required
            value={formik.values.contributorName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.contributorName && formik.errors.contributorName
                ? true
                : false
            }
            name="contributorName"
            placeholder={"Enter Contributor Name"}
            label="Contributor Name"
            fullWidth
          />
          {formik.touched.contributorName && formik.errors.contributorName && (
            <FormHelperText className="error_message">
              {formik.errors.contributorName}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={4}>
          <CustomTextField
            fieldType="textInput"
            name="duration"
            label="Duration(Weeks)"
            placeholder={"Enter Duration(Weeks)"}
            fullWidth
            required
            value={formik.values.duration}
            onBlur={formik.handleBlur}
            onChange={(e) => handleDuration(e)}
            error={
              formik.touched.duration && formik.errors.duration ? true : false
            }
          />
          {formik.touched.duration && formik.errors.duration && (
            <FormHelperText className="error_message">
              {formik.errors.duration}
            </FormHelperText>
          )}
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box>
            <FormControl sx={{ width: 330 }}>
              <InputLabel
                id="demo-multiple-name-label"
                error={
                  formik.touched.explore_id && formik.errors.explore_id
                    ? true
                    : false
                }
              >
                Content List*
              </InputLabel>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                sx={{ background: "white" }}
                value={formik.values.explore_id}
                onChange={handleChange}
                input={<OutlinedInput label="Content List" />}
                renderValue={(selected) =>
                  selected
                    .map(
                      (value) =>
                        contentList.find((item) => item.Id === value)?.title
                    )
                    .join(", ")
                }
                MenuProps={MenuProps}
                error={
                  formik.touched.explore_id && formik.errors.explore_id
                    ? true
                    : false
                }
              >
                {contentList.map((name, index) => (
                  <MenuItem
                    style={{ justifyContent: "start" }}
                    key={index}
                    value={name.Id}
                  >
                    <Checkbox
                      checked={formik.values.explore_id.indexOf(name.Id) > -1}
                    />
                    {name.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {formik.errors.explore_id && formik.touched.explore_id && (
              <FormHelperText className="error_message">
                {formik.errors.explore_id}
              </FormHelperText>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Commitment Level *
          </FormLabel>
        </Grid>
        <Grid item xs={12}>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="light"
            name="commitmentLevel"
            value={formik.values.commitmentLevel}
            onChange={formik.handleChange}
            label="Commitment Level"
          >
            <FormControlLabel value="light" control={<Radio />} label="Light" />
            <FormControlLabel
              value="intermediate"
              control={<Radio />}
              label="Intermediate"
            />
            <FormControlLabel value="high" control={<Radio />} label="High" />
          </RadioGroup>
          {formik.touched.commitmentLevel && formik.errors.commitmentLevel && (
            <FormHelperText className="error_message">
              {formik.errors.commitmentLevel}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Cover Image *
          </FormLabel>
          {formik.errors.coverImage && formik.touched.coverImage && (
            <FormHelperText className="error_message">
              {formik.errors.coverImage}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={6}>
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
            }}
            variant="contained"
            component="label"
            onKeyDown={handleKeyPress1}
            className="program-cover-img-btn"
            endIcon={<ArrowDropDownCircleIcon />}
          >
            Select File
            <input
              name="coverImage"
              accept="image/*"
              id="contained-button-file1"
              type="file"
              hidden
              ref={fileInputRef1}
              onChange={(e) => {
                formik.setTouched({ ...formik.touched, coverImage: true });
                if (e.target.files[0]) {
                  formik.setFieldValue("coverImage", e.target.files[0]);
                }
              }}
            />
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Typography>16:9</Typography>
          <img
            src={
              typeof formik?.values?.coverImage !== "object"
                ? formik?.values?.coverImage
                : URL.createObjectURL(formik?.values?.coverImage)
            }
            width="180px"
            height="150px"
            alt=""
          />
        </Grid>
        <Grid item xs={3}>
          <Typography>1:1</Typography>
          <img
            src={
              typeof formik?.values?.coverImage !== "object"
                ? formik?.values?.coverImage
                : URL.createObjectURL(formik?.values?.coverImage)
            }
            width="180px"
            height="150px"
            alt=""
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            fieldType="textInput"
            name="shortDescription"
            label="Short Description"
            placeholder={"Enter Your Short description"}
            required
            fullWidth
            value={formik.values.shortDescription}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 130 }}
            InputProps={{
              endAdornment: (
                <InputAdornment disableTypography position="end">
                  {`${formik.values.shortDescription?.length}/130`}
                </InputAdornment>
              ),
            }}
            error={
              formik.touched.shortDescription && formik.errors.shortDescription
                ? true
                : false
            }
          />
          {formik.touched.shortDescription &&
            formik.errors.shortDescription && (
              <FormHelperText className="error_message">
                {formik.errors.shortDescription}
              </FormHelperText>
            )}
        </Grid>
        <Grid item xs={12}>
          <MyEditor
            name="fullDescription"
            value={formik.values.fullDescription}
            // onBlur={formik.handleBlur}
            onChange={(data) => {
              formik.setFieldValue("fullDescription", data);
            }}
          />
          {formik.touched.fullDescription && formik.errors.fullDescription && (
            <FormHelperText className="error_message">
              {formik.errors.fullDescription}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Trailer
          </FormLabel>
          {formik?.errors?.trailer && formik?.touched?.trailer && (
            <FormHelperText className="error_message">
              {formik?.errors?.trailer}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            component="label"
            onKeyDown={handleKeyPress2}
            className="program-cover-img-btn"
            endIcon={<ArrowDropDownCircleIcon />}
          >
            Select File
            <input
              name="trailer"
              id="contained-button-file"
              type="file"
              ref={fileInputRef2}
              hidden
              onChange={(e) => {
                formik.setTouched({
                  ...formik.touched.trailer,
                  trailer: true,
                });
                const fileReader = new FileReader();
                fileReader.onload = () => {
                  if (fileReader.readyState === 2) {
                    formik.setFieldValue("trailer", e.target.files[0]);
                  }
                };
                e.target.files[0] &&
                  fileReader.readAsDataURL(e.target.files[0]);
                const fileObj = e.target.files[0];
                if (fileObj) {
                  if (fileObj.type === "video/mp4") {
                    const video = document.createElement("video");
                    video.preload = "metadata";
                    video.onloadedmetadata = () => {
                      URL.revokeObjectURL(video.src);
                      formik.setFieldValue(
                        "trailer_duration",
                        Math.floor(video.duration)
                      );
                    };
                    video.src = URL?.createObjectURL(fileObj);
                  } else {
                    formik.setFieldValue("trailer_duration", null);
                  }
                }
              }}
            />
          </Button>
        </Grid>

        {typeof formik?.values?.trailer === "string" &&
          (formik?.values?.trailer.toLowerCase().endsWith(".mp4") ? (
            <Grid item xs={3}>
              <iframe src={formik?.values?.trailer} title="trailer" />
            </Grid>
          ) : (
            (formik?.values?.trailer.toLowerCase().endsWith(".jpg") ||
              formik?.values?.trailer.toLowerCase().endsWith(".png") ||
              formik?.values?.trailer.toLowerCase().endsWith(".jpeg")) && (
              <Grid item xs={3}>
                <img
                  src={formik?.values?.trailer}
                  alt=""
                  width="200px"
                  height="200px"
                />
              </Grid>
            )
          ))}
        {typeof formik?.values?.trailer == "object" &&
        formik?.values?.trailer?.type == "video/mp4" ? (
          <Grid item xs={3}>
            <iframe
              src={URL.createObjectURL(formik?.values?.trailer)}
              title="trailer"
            />
          </Grid>
        ) : formik.values?.trailer?.type == "image/jpg" ||
          formik.values?.trailer?.type == "image/jpeg" ||
          formik.values?.trailer?.type == "image/png" ? (
          <Grid item xs={3}>
            <img
              src={URL.createObjectURL(formik.values?.trailer)}
              alt=""
              width="200px"
              height="200px"
            />
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12}>
          <Button
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              lineHeight: "0px",
              padding: "13px 30px !important",
            }}
            className="program-next-btn"
            variant="contained"
            onClick={formik.handleSubmit}
          >
            <span>Next</span>
            <img src={rightArrow} alt="" />
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
